import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotMelons from './components/HotMelons';
import LiveRooms from './components/LiveRooms';
import Guide from './components/Guide';
import Faq from './components/Faq';
import About from './components/About';
import SubmitSection from './components/SubmitSection';
import Footer from './components/Footer';
import { faqItems } from './components/About';

function FaqSchema() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
}

export default function Home() {
  return (
    <div className="min-h-screen">
      <FaqSchema />
      <Navbar />
      <main>
        <Hero />
        <HotMelons />
        <LiveRooms />
        <Guide />
        <Faq />
        <About />
        <SubmitSection />
      </main>
      <Footer />
    </div>
  );
}